import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { isScrollingDisabled, manageDisableScrolling } from '../../ducks/ui.duck';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn, Footer, SecondaryButton } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import { withViewport } from '../../util/uiHelpers';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { useConfiguration } from '../../context/configurationContext';
import css from './LandingPage.module.css';

//Static assets
import facebookImage from '../../assets/vivianlab-brandImage.png';
import twitterImage from '../../assets/vivianlab-brandImage.png';

//Section pages
import SectionHero from './SectionHero';
import SectionTestimonial from './SectionTestimonial';
import SectionBlogs from './SectionBlogs';
import SectionFAQ from './SectionFAQ';
import { isArrayLength } from '../../util/genericHelpers';
import { fetchLandingBlogsData } from '../BlogPage/BlogPage.duck';

import WhatVivianlabOffers from './WhatVivianlabOffers/WhatVivianlabOffers';
import SymptomsAreReal from './SymptomsAreReal/SymptomsAreReal';
import MeetVivian from './MeetVivian/MeetVivian';
import AiPromptSection from './AiPromptSection/AiPromptSection';
import SectionHowVivianWorksVideo from './SectionHowVivianWorksVideo/SectionHowVivianWorksVideo';
import SectionScientificGuidance from './SectionScientificGuidance/SectionScientificGuidance';
import SectionAllInOne from './SectionAllInOne/SectionAllInOne';
import SectionFeelBetter from './SectionFeelBetter/SectionFeelBetter';
import SectionCollaborationLogos from './SectionCollaborationLogos/SectionCollaborationLogos';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routing/routeConfiguration';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { decryptString } from '../../util/securityHelpers';

export const LandingPageComponent = props => {
  const { intl, scrollingDisabled, isAuthenticated, viewport, blogsData } = props;

  const dispatch = useDispatch();
  const history = useHistory()

  useEffect(() => {
    dispatch(fetchLandingBlogsData(intl.locale));
  }, [intl.locale]);

  const config = useConfiguration();

  const siteTitle = config.marketplaceName;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({
    id: 'LandingPage.schemaDescription',
  });
  const schemaImage = `${config.marketplaceRootURL}${facebookImage}`;


    const onRedirectToPage = (page, params = {}) => {
    history.push(createResourceLocatorString(page, routeConfiguration(), params, {}));
  };


  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        {
          url: `${config.marketplaceRootURL}${twitterImage}`,
          width: 600,
          height: 314,
        },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        isStaticPage={true}
        className={css.pageRoot}
        topbar={<TopbarContainer isLandingPage isFullWidthHeader isPostLandingPage />}
        footer={<Footer />}
      >
        <div className={css.pageContent} data-testid="landing-page-content">
          <SectionHero viewport={viewport} isAuthenticated={isAuthenticated} />
          <WhatVivianlabOffers viewport={viewport} />
          <SymptomsAreReal viewport={viewport} />
          <MeetVivian viewport={viewport} onRedirectToPage={onRedirectToPage} />
          <AiPromptSection intl={intl} viewport={viewport} />
          <SectionHowVivianWorksVideo intl={intl} viewport={viewport} />
          <SectionScientificGuidance intl={intl} viewport={viewport} />
          <SectionAllInOne intl={intl} viewport={viewport} />
          <SectionFeelBetter intl={intl} viewport={viewport} />
          <SectionTestimonial intl={intl} viewport={viewport} />
          <SectionCollaborationLogos viewport={viewport} />
          {isArrayLength(blogsData) ? <SectionBlogs blogs={blogsData} viewport={viewport} onRedirectToPage={onRedirectToPage}/> : null}
          <SectionFAQ intl={intl} viewport={viewport} />
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool } = PropTypes;

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser, currentUserHasListings, currentUserHasPendingListings } = state.user;
  const { isAuthenticated } = state.auth;
  const { landingBlogsData } = state.BlogPage;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
    currentUserHasListings,
    currentUserHasPendingListings,
    isAuthenticated,
    blogsData: landingBlogsData || [],
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const LandingPage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withViewport,
  injectIntl
)(LandingPageComponent);

export default LandingPage;
